import qs from 'qs';
import { encodeUrlSafeBase64 } from '@/mikan/_shared/lib/utilities/base64';

// index
export const buildRestaurantIndexUrl = restaurantId => `/restaurant/index/${restaurantId}`;

// spots
export const buildSpotsBaseUrl = `/restaurant/v2/inventory/spots`;
export const buildSetOrderOfSpotsApiEndpoint = restaurantId => `${buildSpotsBaseUrl}/set-order-num/${restaurantId}`;
export const buildSpotDeletionUrl = (restaurantId, spotId) => `${buildSpotsBaseUrl}/delete/${spotId}/${restaurantId}`;
export const buildSpotCreationUrl = restaurantId => `${buildSpotsBaseUrl}/edit/${restaurantId}`;
export const buildSpotEditionUrl = (restaurantId, spotId) => `${buildSpotsBaseUrl}/edit/${spotId}/${restaurantId}`;


// seats: spots for contents
// FIXME: SeatをSpotに統合できたら消す
const buildSeatsBaseUrl = `/restaurant/seats`;
export const buildSaveSeatsApiEndpoint = restaurantId => `${buildSeatsBaseUrl}/save/${restaurantId}`;

// stocks
export const buildStockCreationUrl = restaurantId =>
  `/restaurant/v2/inventory/mobile-stocks/bulk-create/${restaurantId}`;
export const buildStockCreationApiEndpoint = restaurantId =>
  `/restaurant/v2/inventory/mobile-stocks/post-bulk-create/${restaurantId}`;
export const buildStockDeletionApiEndpoint = restaurantId =>
  `/restaurant/v2/inventory/mobile-index/delete-stock-api/${restaurantId}`;
export const buildNumberOfStocksApiEndpoint = (restaurantId, startDate, endDate) => {
  const query = qs.stringify({ start: startDate, end: endDate });
  return `/restaurant/v2/inventory/mobile-index/number-of-stocks-api/${restaurantId}?${query}`;
};
export const buildStockListApiEndpoint = (restaurantId, date, offset, limit) => {
  const query = qs.stringify({ date, offset, limit });
  return `/restaurant/v2/inventory/mobile-index/stock-list-api/${restaurantId}?${query}`;
};

export const buildUpdateAcceptingStatusOfStockApiEndpoint = restaurantId =>
  `/restaurant/v2/inventory/mobile-index/update-stock-state-api/${restaurantId}`;
export const buildRestaurantsPropsOnReservationCheckListApiEndpoint = (restaurantId, date, page, filterStatus = 0) => {
  const params = { date, pageNum: page };
  if (filterStatus > 0) {
    params.filterStatus = filterStatus;
  }
  const query = qs.stringify(params);
  return `/restaurant/v2/inventory/mobile-index/restaurants-props-on-reservation-check-list-api/${restaurantId}?${query}`;
};

// booking(reservations)
export const buildBookingIndexUrl = restaurantId =>
  `/restaurant/v2/inventory/mobile-index/reservations/${restaurantId}`;
export const buildBookingDetailUrl = (restaurantId, bookingId) =>
  `/restaurant/v2/inventory/reservations/show/${bookingId}/${restaurantId}`;
export const buildBookingRequestedUrl = restaurantId =>
  `/restaurant/v2/inventory/mobile-index/request-reservations/${restaurantId}`;
export const buildCheckReservationsUrl = restaurantId =>
  `/restaurant/v2/inventory/mobile-index/reservation-check-list/${restaurantId}`;
export const buildImageSelectorUrl = restaurantId => `/restaurant/images/choice/${restaurantId}`;
export const buildEdittingRestaurantInformationUrl = restaurantId => `/restaurant/cover/${restaurantId}`;
export const buildAccessAnalysisIndexUrl = restaurantId => `/restaurant/analytics/${restaurantId}`;
export const buildSettingIndexUrl = restaurantId => `/restaurant/setting/${restaurantId}`;
export const buildPublicationPriorityIndexUrl = restaurantId => `/restaurant/publication-priority/${restaurantId}`;
export const buildNotificationsUrl = restaurantId => `/restaurant/index/fan-activities/${restaurantId}`;
export const buildMessageSelectRecipientUrl = restaurantId => `/restaurant/message/select-recipient/${restaurantId}`;
export const buildNewsUrl = restaurantId => `/restaurant/news/${restaurantId}`;
export const buildSettingLogoUrl = restaurantId => `/restaurant/profile/change-logo/${restaurantId}`;
export const buildUserAnalysisIndexUrl = restaurantId => `/restaurant/user-analysis/marketing/${restaurantId}`;
export const buildReservationSettingUrl = restaurantId => `/restaurant/setting/reservation-setting/${restaurantId}`;

// alliance
export const buildSaveGoogleReservationAvailabilityEndpoint = reservationId =>
  `/restaurant/alliance/google-availability/${reservationId}`;
export const buildLinePlaceConnectiongUrl = restaurantId =>
  `/restaurant/alliance/line-place-connecting/${restaurantId}`;
export const buildUpdateLineAddressUrl = restaurantId =>
  `/restaurant/alliance/updateLine-address/${restaurantId}`;
export const buildDeactivateLineUrl = restaurantId =>
  `/restaurant/alliance/line-reservation-deactivation/${restaurantId}`;
export const buildReactivateLineUrl = restaurantId =>
  `/restaurant/alliance/line-reservation-reactivation/${restaurantId}`;
export const buildLinkLineOAuthUrl = (origin, linePartnerId, restaurantId, token)  => {
  const redirectUrl = `${origin}/line-oa-integration`;
  const params = new URLSearchParams();
  params.set('partnerId', linePartnerId);
  params.set('merchantId', restaurantId);
  params.set('redirectUri', encodeURI(redirectUrl));

  // redirectUri先でRettyとして欲しい情報をstateに入れる。
  // 連携先の LINE 側 ID 基盤の要件で state には "unique alphanumeric string" しか
  // 入れられないとのことなので、JSON+base64url でエンコードする。
  const state = {
    token,
    id: restaurantId,
  }
  params.set('state', encodeUrlSafeBase64(JSON.stringify(state)));

  return `https://integration-reservation.line.me/v1/oa/integration?${params.toString()}`
}

export const buildRedirectRestaurantPageUrl = restaurantId => {
  const query = qs.stringify({ redirect: `https://retty.me/restaurant/${restaurantId}` });
  return `/restaurant/${restaurantId}/?${query}`;
};
export const buildSettingCurrentDayNotice = restaurantId => `/restaurant/setting/current-day-notice/${restaurantId}`;
export const buildRestaurantSettingStatusUrl = restaurantId => `/restaurant/setting-status/${restaurantId}`;

// UserAnalysis
export const buildActionedUserListApiEndPoint = (restaurantId, offset, limit) => {
  const query = qs.stringify({ offset, limit });
  return `/restaurant/user-analysis/actioned-user-list-api/${restaurantId}?${query}`;
};
export const buildActionedUserListApiEndPointBase = restaurantId =>
  `/restaurant/user-analysis/actioned-user-list-api/${restaurantId}?`;
export const buildInformationForMemberUrl = () => 'https://go.pardot.com/l/702363/2019-12-04/7btqg';
export const buildInformationForTakeoutUrl = () => 'https://go.pardot.com/l/702363/2020-04-16/yw1qs';
export const buildInquiryForFreeMemberUrl = () => 'https://own.retty.me/otoiawase';
export const buildEmailConfirmationGoogleFormUrl = () => 'https://docs.google.com/forms/d/e/1FAIpQLSd9a6iw0q33PbNb8ivZiSHaM2A1llrR1EngaeRhNFyiuxs7CA/viewform'

// User Profile Page
export const buildUserProfilePageUrl = userId => `https://retty.me/user/${userId}/`;

// Resraku Banner
export const buildInformationForResrakuUrl = () => 'https://bit.ly/317DdJ7';

// Advertise Setting (HistoryController correctGenreAndPurpose)
export const buildAdvertiseSettingUrl = restaurantId => `/restaurant/history/correct-genre-and-purpose/${restaurantId}`;

export const buildAdvertiseAutomationSettingUrl = restaurantId =>
  `/restaurant/category-and-purpose/setting/${restaurantId}`;
export const buildDeleteAdOptimizationSettingsUrl = restaurantId =>
  `/restaurant/history/delete-ad-optimization-settings/${restaurantId}`;

export const buildAcpAcoFormUrl = restaurantId => `/restaurant/category-and-purpose/setting/${restaurantId}`;

export const buildSelectingRettyOrderAccountUrl = restaurantId =>
  `/restaurant/retty-order/redirect-login-page/${restaurantId}`;

export const buildViewingNpsPopupUrl = restaurantId => `/restaurant/last-viewed/save-nps/${restaurantId}`;

export const buildHomepageSettingUrl = restaurantId => `/restaurant/homepage/setting/${restaurantId}`;
export const buildHomepageIndexUrl = restaurantId => `/restaurant/homepage/${restaurantId}`;

export const buildRestaurantIndexLineForMemberUrl = () => 'https://own.retty.me/line';
export const buildRestaurantIndexFormForMemberUrl = () => 'https://own.retty.me/l/998041/2023-01-27/64x5';

export const buildPopularRestaurantImageAndCatchcopySettingsUrl = restaurantId => `/restaurant/popular-restaurant-settings/image-and-catchcopy/${restaurantId}`;

export const buildSetOrderCoursesUrl = restaurantId => `/restaurant/v2/inventory/courses/set-order-num/${restaurantId}`;
export const buildCourseEditUrl = (restaurantId, courseId) => `/restaurant/v2/inventory/courses/edit/${courseId}/${restaurantId}`;
export const buildCourseCloneUrl = (restaurantId, courseId) => `/restaurant/v2/inventory/courses/clone/${courseId}/${restaurantId}`;
export const buildMenuUpdateUrl = restaurantId => `/restaurant/menu/change/${restaurantId}`;
export const buildMenuEditUrl = (restaurantId, menuId) => `/restaurant/menu/edit/${menuId}/${restaurantId}`;
export const buildReplaceMenusUrl = restaurantId => `/restaurant/menu/replace-menus/${restaurantId}`;

export const buildPhotoUpdateUrl = restaurantId => `/restaurant/photos/change/${restaurantId}`;
export const buildGetPhotoStatusUrl = (restaurantId, status) => {
  const query = qs.stringify({ status });
  return `/restaurant/v2/inventory/photos/${restaurantId}?${query}`;
};
export const buildPhotoIndexUrl = (restauranatId, listKind) => {
  const query = qs.stringify({ listKind });
  return listKind ? `/restaurant/photos/${restauranatId}?${query}` : `/restaurant/photos/${restauranatId}`;
};
export const buildPhotoEditUrl = (restauranatId, kind) => {
  const query = qs.stringify({ kind });
  return kind ? `/restaurant/photos/edit/${restauranatId}?${query}` : `/restaurant/photos/${restauranatId}`;
};

export const buildReOrderPhotosUrl = restaurantId => `/restaurant/photos/reorder/${restaurantId}`;
export const buildDeletePhotosUrl = restaurantId => `/restaurant/photos/delete/${restaurantId}`;
export const buildDeletePhotoUrl = (restaurantId, photoId) => `/restaurant/photos/delete/${photoId}/${restaurantId}`;

export const buildPromotionVideoSettingUrl = restaurantId => `/restaurant/promotion-video/setting/${restaurantId}`;
export const buildPromotionVideoDeleteUrl = restaurantId => `/restaurant/promotion-video/delete/${restaurantId}`;
export const buildPromotionVideoGetPresignUrl = restaurantId => `/restaurant/promotion-video/get-presign-url/${restaurantId}`;

export const buildRettyDXLinkUrl = () => 'https://biz.retty.biz/users/sign_in';
export const buildExternalLinkUrl = restaurantId => `/restaurant/external-link/${restaurantId}`;

export const buildRestrictedPageDefaultBunnerInquiryUrl = () => 'https://own.retty.me/l/998041/2023-03-03/8m65'
export const buildRestrictedPageFreeMemberInquiryUrl = () => 'https://own.retty.me/l/998041/2024-11-01/2gjp4'
export const buildRestrictedPageDefaultInquiryUrl = () => 'https://own.retty.me/l/998041/2024-12-06/2jl4d'
